export default "__VITE_ASSET__8IUZRHLC__"